/**
 * Application constants.
 * @type {Local.AppConstants}
 */
export const Constants = {
  AppName: 'Production Request',
  PostLogoutRoute: '/',
};

/**
 * Okta configuration.
 * @type {Local.OktaConfig}
 */
export const OktaConfig = {
  issuer: window.REACT_APP_OKTA_ISSUER ?? process.env.REACT_APP_OKTA_ISSUER,
  clientId: window.REACT_APP_OKTA_CLIENTID ?? process.env.REACT_APP_OKTA_CLIENTID,
  redirectUri: `${window.location.origin}/login/callback`,
  scopes: [
    'openid',
    'profile',
    'email',
    'offline_access',
    'ApiGw.teammembers',
    'ApiGw.appl-user',
    'ApiGw.app-analytics',
    'ApiGw.ebs-api',
    'ebs_customer_read',
    'ebs_customer_write',
    'ApiGw.production-request',
    'production_request_read',
    'production_request_write',
  ],
  pkce: true,
  disableHttpsCheck: window.OKTA_TESTING_DISABLEHTTPSCHECK || false,
  postLogoutRedirectUri: `${window.location.origin}/logout`,
};

/**
 * EBS instance configuration.
 * @type {Local.EBSInstance[]} EBSInstances
 */
export const ebsInstances = [
  { name: 'DEV', instanceID: 'EBSDEV' },
  { name: 'DEV2', instanceID: 'EBSDEV2' },
  { name: 'DEV3', instanceID: 'EBSDEV3' },
  { name: 'DEV4', instanceID: 'EBSDEV4' },
  { name: 'DEV5', instanceID: 'EBSDEV5' },
  { name: 'DEV6', instanceID: 'EBSDEV6' },
];

export const isDev = window.REACT_APP_API_URL?.includes('apidev');
